import requests from './requests';

export default {
    daily(date) {
        return requests
            .get(`/coach/courses/${date}`)
            .then(resp => resp.data);
    },
    stats(date) {
        return requests
            .get(`/coach/courses/${date}/stats`)
            .then(resp => resp.data);
    },
    multiStats(dates) {
        return requests
            .post('/coach/courses/stats_by_dates', {
                dates,
            })
            .then(resp => resp.data);
    },
    programs() {
        return requests
            .get('/programs')
            .then(resp => resp.data);
    },
    get(id) {
        return requests
            .get(`/coach/course/${id}`)
            .then(resp => resp.data);
    },
    post(course) {
        return requests
            .post('/coach/course', course)
            .then(resp => resp.data);
    },
    patch(id, course) {
        return requests
            .patch(`/coach/course/${id}`, course)
            .then(resp => resp.data);
    },
    patchCurrent(id, course) {
        return requests
            .patch(`/coach/course/${id}/current`, course)
            .then(resp => resp.data);
    },
    notify(id) {
        return requests
            .put(`/coach/course/${id}/notify`)
            .then(resp => resp.data);
    },
    close(id) {
        return requests
            .put(`/coach/course/${id}/close`)
            .then(resp => resp.data);
    },
    deleteCurrent(id) {
        return requests
            .delete(`/coach/course/${id}/current`)
            .then(resp => resp.data);
    },
    deleteRemaining(id) {
        return requests
            .delete(`/coach/course/${id}/remaining`)
            .then(resp => resp.data);
    },
    delete(id) {
        return requests
            .delete(`/coach/course/${id}`)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/course.js